/* HORUS DE - preenchimento direcional nos botoes.
   Portado do tema da horusfashion.com, onde o custom element
   <hover-button> faz exatamente isto: descobre por qual borda o
   ponteiro entrou e marca o botao com uma classe de direcao. O CSS
   (bloco 13 do horus-custom.css) usa essa classe como transform-origin.

   Diferenca em relacao a .com: la o efeito e so de hover, o que no
   celular nunca acontece. Aqui ele dispara tambem no toque/clique,
   via classe is-pressed. */
(function () {
  var SELECTOR = '.button:not([disabled]):not([aria-disabled="true"])';
  var DIRECTIONS = ['button--from-top', 'button--from-right', 'button--from-bottom', 'button--from-left'];

  function edgeFrom(button, x, y) {
    var box = button.getBoundingClientRect();
    if (!box.width || !box.height) return 'button--from-left';

    var top = y - box.top;
    var right = box.right - x;
    var bottom = box.bottom - y;
    var left = x - box.left;

    var nearest = Math.min(top, right, bottom, left);
    if (nearest === top) return 'button--from-top';
    if (nearest === right) return 'button--from-right';
    if (nearest === bottom) return 'button--from-bottom';
    return 'button--from-left';
  }

  function setDirection(button, x, y) {
    button.classList.remove.apply(button.classList, DIRECTIONS);
    button.classList.add(edgeFrom(button, x, y));
  }

  document.addEventListener('pointerenter', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (button) setDirection(button, event.clientX, event.clientY);
  }, true);

  document.addEventListener('pointerdown', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!button) return;
    setDirection(button, event.clientX, event.clientY);
    button.classList.add('is-pressed');
  }, true);

  function release() {
    var pressed = document.querySelectorAll('.button.is-pressed');
    for (var i = 0; i < pressed.length; i++) pressed[i].classList.remove('is-pressed');
  }

  document.addEventListener('pointerup', release, true);
  document.addEventListener('pointercancel', release, true);
})();
